// Pagina in cui andare dopo il login: l'indirizzo richiesto prima (link diretto o sessione scaduta),
// altrimenti la pagina iniziale (Hub per lo studio). Solo percorsi interni.
export function destinazioneDopoLogin(location) {
  const da = location?.state?.da || new URLSearchParams(location?.search || '').get('da') || '/';
  return da.startsWith('/') && !da.startsWith('//') && !da.startsWith('/login') ? da : '/';
}
